import { Component, OnInit } from '@angular/core';
import { ActionParams } from '../../_models/actions';
import { SessionTileParams } from '../../_models/session';
import { SessionService, ActionService } from '../../_services/index';
import { MediaObserver } from '@ngbracket/ngx-layout';
import { Router } from '@angular/router';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { AuthenticationStateHelperService } from '../../_helpers/authentication-state-helper/authentication-state-helper.service';

@Component({
    selector: 'coordinator-main',
    templateUrl: 'coordinator.landing.component.html',
    standalone: false
})

export class CoordinatorMainComponent implements OnInit {

  actionDataParams: ActionParams = new ActionParams();
  sessionTileParams: SessionTileParams = new SessionTileParams();
  sessionDataTomorrow: SessionTileParams = new SessionTileParams();

  constructor(
    private sessionService: SessionService,
    private actionService: ActionService,
    public media: MediaObserver,
    public router: Router,
    private featureHelperService: FeatureHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService
  ) { }

  ngOnInit() {
    
    let featureList = new Array<string>();
    featureList.push("CoordinatorHomeView");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

    if (!currentUserFeatures.filter(f => f.feature === "CoordinatorHomeView")[0].enabled) {
      console.error("User does not have the required permissions to view the coordinator landing screen");
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
      this.authenticationStateHelper.unauthorizedToken = true;
    }

    this.sessionService.getSessionTileDates(new Date());
    this.sessionTileParams = this.sessionService.sessionDataParamToday;
    this.sessionTileParams.sessionHeader = 'Sessions Today';
    this.sessionTileParams.sessionNodata = 'There are no sessions today';
    this.sessionDataTomorrow = {
      sessionHeader: 'Sessions Tomorrow',
      startDate: this.addDays(new Date(), 1),
      endDate: this.addDays(new Date(), 1),
      excludeToday: true,
      mode: true,
      sessionNodata: 'There are no sessions tomorrow'
    }
    this.actionService.changeMessage({});
  }

  private addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
}
